import { connect } from 'react-redux';

import LearningAdminModulesTableScreen from '../components/LearningAdminModulesTableScreen';

const mapStateToProps = (state, ownProps) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

const LearningAdminModulesTableScreenContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(LearningAdminModulesTableScreen);

export default LearningAdminModulesTableScreenContainer;
